export default function Header({
  imageURL,
  title,
  subTitle = null,
  titleSize = 48,
  subTitleSize = 16,
  yOffset = 0,
  stretchHeight = '100%',
  opacity = 0.04,
  windowWidth,
}) {
  return (
    <>
      <div style={{ position: 'relative', width: '100%' }}>
        <svg
          width='100%'
          height={windowWidth > 750 ? '235px' : '150px'}
          viewBox='0 0 1440 248'
          preserveAspectRatio='none'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M0 0V215C0 226.046 8.9543 235 20 235H325.717C341.519 235 357.095 231.255 371.17 224.073L446.762 185.499C460.837 178.317 476.413 174.573 492.215 174.573H968.14C983.065 174.573 997.801 177.914 1011.27 184.351L1096.77 225.222C1110.23 231.659 1124.97 235 1139.9 235H1420C1431.05 235 1440 226.046 1440 215V0H0Z'
            fill='url(#paint0_radial_125_110)'
            filter='url(#shadow)'
          />

          <image
            href={imageURL}
            x='0'
            y={yOffset}
            width='100%'
            height={stretchHeight}
            opacity={opacity}
            preserveAspectRatio='xMidYMid slice'
            mask='url(#path-mask)'
          />

          <defs>
            <mask id='path-mask' x='0' y='0' width='100%' height='100%' maskUnits='userSpaceOnUse'>
              <path
                d='M0 0V215C0 226.046 8.9543 235 20 235H325.717C341.519 235 357.095 231.255 371.17 224.073L446.762 185.499C460.837 178.317 476.413 174.573 492.215 174.573H968.14C983.065 174.573 997.801 177.914 1011.27 184.351L1096.77 225.222C1110.23 231.659 1124.97 235 1139.9 235H1420C1431.05 235 1440 226.046 1440 215V0H0Z'
                fill='white'
              />
            </mask>

            <filter id='shadow' x='0' y='0' width='140%' height='140%'>
              <feDropShadow dx='0' dy='4' stdDeviation='4' floodColor='rgba(0, 0, 0, 0.5)' />
            </filter>

            <radialGradient
              id='paint0_radial_125_110'
              cx='0'
              cy='0'
              r='1'
              gradientUnits='userSpaceOnUse'
              gradientTransform='translate(719.501 289.561) rotate(90) scale(275.567 638.448)'>
              <stop stopColor='#3F5896' stopOpacity='0.70' />
              <stop offset='1' stopColor='#3F5896' />
            </radialGradient>
          </defs>
        </svg>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            position: 'absolute',
            top: windowWidth > 750 ? 'calc(50% - 40px)' : 'calc(50% - 15px)',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            flexDirection: 'column',
            gap: '4px',
            width: '90%'
          }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <svg width='52' height='7' viewBox='0 0 52 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M0.333333 3.5C0.333333 4.97276 1.52724 6.16667 3 6.16667C4.47276 6.16667 5.66667 4.97276 5.66667 3.5C5.66667 2.02724 4.47276 0.833333 3 0.833333C1.52724 0.833333 0.333333 2.02724 0.333333 3.5ZM46.3333 3.5C46.3333 4.97276 47.5272 6.16667 49 6.16667C50.4728 6.16667 51.6667 4.97276 51.6667 3.5C51.6667 2.02724 50.4728 0.833337 49 0.833337C47.5272 0.833337 46.3333 2.02724 46.3333 3.5ZM3 4L49 4L49 3L3 3L3 4Z'
                fill='white'
              />
            </svg>

            <p style={{ color: 'white', margin: '0', fontSize: `${titleSize}px`, fontFamily: 'Jura', fontWeight: 'bold', textAlign: 'center' }}>
              {title}
            </p>

            <svg width='52' height='7' viewBox='0 0 52 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M0.333333 3.5C0.333333 4.97276 1.52724 6.16667 3 6.16667C4.47276 6.16667 5.66667 4.97276 5.66667 3.5C5.66667 2.02724 4.47276 0.833333 3 0.833333C1.52724 0.833333 0.333333 2.02724 0.333333 3.5ZM46.3333 3.5C46.3333 4.97276 47.5272 6.16667 49 6.16667C50.4728 6.16667 51.6667 4.97276 51.6667 3.5C51.6667 2.02724 50.4728 0.833337 49 0.833337C47.5272 0.833337 46.3333 2.02724 46.3333 3.5ZM3 4L49 4L49 3L3 3L3 4Z'
                fill='white'
              />
            </svg>
          </div>

          {subTitle && (
            <p style={{ color: 'white', margin: '0', fontSize: `${subTitleSize}px`, fontFamily: 'Jura', fontWeight: 'bold', textAlign: 'center' }}>
              {subTitle}
            </p>
          )}
        </div>

        {windowWidth > 750 && (
          <>
            <svg
              style={{ position: 'absolute', left: '50px', top: 'calc(50% - 40px)' }}
              width='30%'
              height='74'
              viewBox='0 0 320 74'
              preserveAspectRatio='none'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M1 71.5C0.447715 71.5 0 71.9477 0 72.5C0 73.0523 0.447715 73.5 1 73.5V71.5ZM223.596 17.2952L223.016 16.4804L223.596 17.2952ZM274.609 1V0V1ZM1 73.5H117.891V71.5H1V73.5ZM169.484 57.0197L224.175 18.11L223.016 16.4804L168.325 55.39L169.484 57.0197ZM274.609 2H319.5V0H274.609V2ZM224.175 18.11C238.905 7.63083 256.533 2 274.609 2V0C256.117 0 238.084 5.76027 223.016 16.4804L224.175 18.11ZM117.891 73.5C136.383 73.5 154.416 67.7397 169.484 57.0197L168.325 55.39C153.595 65.8692 135.967 71.5 117.891 71.5V73.5Z'
                fill='url(#paint0_linear_230_570)'
              />
              <defs>
                <linearGradient id='paint0_linear_230_570' x1='1.00001' y1='73' x2='319' y2='1.0001' gradientUnits='userSpaceOnUse'>
                  <stop stopColor='#749DFF' />
                  <stop offset='1' stopColor='#749DFF' stopOpacity='0' />
                </linearGradient>
              </defs>
            </svg>

            <svg
              style={{ position: 'absolute', right: '50px', top: 'calc(50% - 40px)' }}
              width='30%'
              height='74'
              viewBox='0 0 320 74'
              fill='none'
              preserveAspectRatio='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M318.5 71.5C319.052 71.5 319.5 71.9477 319.5 72.5C319.5 73.0523 319.052 73.5 318.5 73.5V71.5ZM95.9044 17.2952L96.4841 16.4804L95.9044 17.2952ZM44.8905 1V0V1ZM318.5 73.5H201.609V71.5H318.5V73.5ZM150.016 57.0197L95.3247 18.11L96.4841 16.4804L151.175 55.39L150.016 57.0197ZM44.8905 2H0V0H44.8905V2ZM95.3247 18.11C80.5952 7.63083 62.9673 2 44.8905 2V0C63.3829 0 81.416 5.76027 96.4841 16.4804L95.3247 18.11ZM201.609 73.5C183.117 73.5 165.084 67.7397 150.016 57.0197L151.175 55.39C165.905 65.8692 183.533 71.5 201.609 71.5V73.5Z'
                fill='url(#paint0_linear_230_580)'
              />
              <defs>
                <linearGradient id='paint0_linear_230_580' x1='318.5' y1='73' x2='0.499981' y2='1.0001' gradientUnits='userSpaceOnUse'>
                  <stop stopColor='#749DFF' />
                  <stop offset='1' stopColor='#749DFF' stopOpacity='0' />
                </linearGradient>
              </defs>
            </svg>
          </>
        )}
      </div>
    </>
  );
}
